import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import TransiluminatorWarning from '@common/images/transiluminator-warning.svg';

export function Warning({style}) {
  return (
    <Image
      src={TransiluminatorWarning}
      style={style}
      alt='transiluminator_warning'
    />
  );
}

Warning.propTypes = {
  /**
   * style to be set on component
   */
  style: PropTypes.object,
};
